"use client";

import { Checkbox } from "@/components/ui/checkbox";
import { cn } from "@/lib/utils";
import { GetFilesResponseType } from "../../../../hooks/useGetFiles";
import { useStorageQuery } from "../../../../hooks/storageQueryProvider";

export default function FileCheckbox({
    file,
    selected,
}: {
    file: GetFilesResponseType["data"][0];
    selected: boolean;
}) {
    const { setSelectedFiles } = useStorageQuery();

    const toggleSelected = () => {
        setSelectedFiles((prev) => {
            if (selected) {
                return prev.filter((f) => f.id !== file.id);
            } else {
                return [...prev, file];
            }
        });
    };

    return (
        <div
            className={cn(
                "flex opacity-0 group-hover:opacity-100 transition-all duration-200",
                selected && "opacity-100"
            )}
        >
            <Checkbox
                className="bg-background"
                checked={selected}
                onClick={(e) => {
                    e.stopPropagation();
                    toggleSelected();
                }}
                onPointerDown={(e) => e.stopPropagation()}
            />
        </div>
    );
}
